export default __webpack_public_path__ + "static/media/Megosu - KarTent - 3.7c231991.jpg";